import { APP } from '../../redux/constants/app.constants';

export const CONNECT_DEVICE_DIALOG = `${APP}/CONNECT_DEVICE_DIALOG`;

export const SET_DEVICE_TO_CONNECT = `${CONNECT_DEVICE_DIALOG}/SET_DEVICE_TO_CONNECT`;
export const SAVE_CONNECTIONS = `${CONNECT_DEVICE_DIALOG}/SAVE_CONNECTIONS`;